module.exports = __webpack_public_path__ + "static/img/btcpriceicon.be23cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btcpriceicon.png
// module id = sSR5
// module chunks = 51